import type { LinkProps } from '@mui/material/Link';
import type { Theme } from '@mui/material/styles';

import { onSurface } from '../../onSurface';

// ----------------------------------------------------------------------

export function typography(theme: Theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
        paragraph: {
          marginBottom: theme.spacing(2),
        },
      },
    },
    // A link is the brand drawn as TEXT, and MUI's default link colour is
    // `primary.main` — a fill colour, 1.74:1 on a cream tenant (the sign-in
    // page's "Register here" was the first thing a light tenant's users would
    // have seen). Only the default colour is re-pointed: a link given another
    // colour on purpose (`inherit`, `text.secondary`, …) keeps it.
    MuiLink: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: LinkProps }) =>
          ownerState.color === 'primary' || ownerState.color === 'primary.main'
            ? {
                color: onSurface.primary,
                textDecorationColor: `color-mix(in srgb, ${onSurface.primary} 40%, transparent)`,
              }
            : {},
      },
    },
  };
}
